import React, { useState, useEffect } from "react";

// Packages import
import {
  Typography,
  Box,
  useTheme,
  TextField,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Pagination,
  Stack,
  Backdrop,
  CircularProgress,
  Snackbar,
  Alert,
  Chip,
} from "@mui/material";
import { outlinedInputClasses } from "@mui/material/OutlinedInput";
import { Search as SearchIcon, Add as AddIcon } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";

// User Import

import DelModal from "./DelModal";
import { RoutesUrls, adminRoutes } from "../../../Services/Routes/APP";
import { headersPost } from "../../../Services/API";
import { ADMIN_API_ULRS } from "../../../Services/Routes/API";
import { getPagination } from "../../../common/functions";

// constants

const headings = [
  "Name",
  "Main Type",
  "Sub Type",
  "Temperature 1",
  "Temperature 2",
  "Temperature 3",
  "Actions",
];

//component

const Products = () => {
  //hooks

  const theme = useTheme();
  const navigate = useNavigate();

  //states

  const [openModal, setOpenModal] = useState(false);
  const [product, setProduct] = useState(null);
  const [page, setPage] = useState(1);
  const [products, setProducts] = useState([]);
  const [open, setOpen] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [alertIcon, setAlertIcon] = useState("error");
  const [api, setApi] = useState(true);
  const [totalCount, setTotalCount] = useState(0);

  //add product handler

  const addHandler = () => {
    navigate(RoutesUrls.admin + adminRoutes.addProduct);
  };

  //update product handler

  const editHandler = (row) => {
    navigate(RoutesUrls.admin + adminRoutes.editProduct, {
      state: {
        product: row,
      },
    });
  };

  //

  const closeModalHandler = () => {
    setOpenModal(false);
  };

  const delProduct = (pro) => {
    // setProduct(pro);
    // setOpenModal(true);
  };

  //get categories

  const getProducts = () => {
    const data = {
      page: page,
    };
    setOpen(true);
    setApi(false);

    headersPost(ADMIN_API_ULRS.GET_ALL_PRODUCTS, data)
      .then((res) => {
        setOpen(false);
        if (res?.status === 200 && res?.data?.success) {
          setProducts(res?.data?.products);
          setTotalCount(res?.data?.total_count);
        } else {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("warning");
        }
      })
      .catch((err) => {
        setOpen(false);
        const { response } = err;
        if (response?.status === 401) {
          localStorage.clear();
          navigate(RoutesUrls?.root);
        } else {
          setAlertOpen(true);
          setAlertMsg(response?.statusText);
          setAlertIcon("error");
        }
      });
  };

  //close alert

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertOpen(false);
  };

  //life cycle

  useEffect(() => {
    api && getProducts();
  }, [api]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setApi(true);
  };

  //

  const minitryDelHandler = () => {
    setOpenModal(false);
    const data = {
      ministry: {
        id: product?.id,
        is_active: product?.is_active ? false : true,
      },
    };
    setOpen(true);

    headersPost(ADMIN_API_ULRS.UPDATE_MINISTRY, data)
      .then((res) => {
        setOpen(false);
        if (res?.status === 200 && res?.data?.success) {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("success");
          setApi(true);
        } else {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("warning");
        }
      })
      .catch((err) => {
        setOpen(false);
        const { response } = err;
        if (response?.status === 401) {
          localStorage.clear();
          navigate(RoutesUrls?.root);
        } else {
          setAlertOpen(true);
          setAlertMsg(response?.statusText);
          setAlertIcon("error");
        }
      });
  };

  // render

  return (
    <Box padding={2}>
      <Box
        display={{ md: "flex", sm: "flex" }}
        justifyContent={{ md: "space-between", sm: "space-between" }}
      >
        <Box paddingBottom={{ xs: 2 }}>
          <Typography
            color={"text.grayText"}
            sx={{
              textTransform: "uppercase",
              paddingBottom: 2,
            }}
          >
            <Typography
              variant="h4"
              fontWeight={"bold"}
              component={"span"}
              sx={{
                paddingBottom: { xs: 0, sm: 1, md: 2 },
                borderBottom: `1px solid ${theme.palette.text.secondary}`,
              }}
            >
              Products
            </Typography>
          </Typography>
        </Box>
        <Box display={{ xs: "flex" }} justifyContent={{ xs: "right" }}>
          <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
            <Button
              color="primary"
              variant="contained"
              size="large"
              onClick={addHandler}
              sx={{
                borderRadius: 8,
                maxHeight: 40,
              }}
              startIcon={<AddIcon />}
            >
              Add Product
            </Button>
          </Stack>
        </Box>
      </Box>

      <Box marginTop={2} display={"flex"} justifyContent={"flex-end"}>
        <TextField
          size="small"
          placeholder="Search"
          InputProps={{
            endAdornment: (
              <SearchIcon
                sx={{
                  color: theme.palette.primary.dark,
                }}
              />
            ),
          }}
          sx={{
            borderRadius: 25,
            backgroundColor: theme.palette.secondary.dark,
            [`.${outlinedInputClasses.root}`]: {
              borderRadius: 25,
              paddingX: 2,
            },
          }}
        ></TextField>
      </Box>
      <Box>
        <TableContainer>
          <Table sx={{ minWidth: 650 }}>
            <TableHead>
              <TableRow>
                {headings?.map((h, index) => (
                  <TableCell
                    sx={{
                      fontWeight: "bold",
                    }}
                    align="center"
                    key={`${index}-table-heading-${h}`}
                  >
                    <Chip
                      label={h}
                      sx={{
                        backgroundColor:
                          index === headings.length - 1
                            ? `${theme.palette.error.light}`
                            : `${theme.palette.secondary.dark}`,
                        borderRadius: 2,
                        color:
                          index === headings.length - 1
                            ? `${theme.palette.error.main}`
                            : `${theme.palette.primary.main}`,
                      }}
                    ></Chip>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {products?.map((row, index) => (
                <TableRow
                  // key={row.name}
                  id={row?.id}
                  key={`${index}-row.name-${index + 2}`}
                >
                  <TableCell align="center"    sx={{
                        wordWrap: "break-word"
                      }}
>{row?.name}</TableCell>
                  <TableCell align="center">{row?.main_type}</TableCell>
                  <TableCell align="center">{row?.sub_type}</TableCell>
                  <TableCell align="center">{row?.temperature1}</TableCell>
                  <TableCell align="center">{row?.temperature2}</TableCell>
                  <TableCell align="center">{row?.temperature3}</TableCell>

                  <TableCell align="center">
                    <Stack
                      direction="row"
                      spacing={2}
                      justifyContent={"center"}
                    >
                      <Button
                        color="primary"
                        variant="contained"
                        size="small"
                        onClick={() => editHandler(row)}
                        sx={{
                          borderRadius: 4,
                        }}
                      >
                        Edit
                      </Button>
                      <Button
                        // color={getColor(row?.is_active)}
                        variant="contained"
                        onClick={() => delProduct(row)}
                        size="small"
                        sx={{
                          backgroundColor:
                            row?.is_active === true
                              ? theme.palette.secondary.main
                              : theme.palette.error.main,
                          borderRadius: 4,
                        }}
                      >
                        {row?.is_active === true ? "Active " : "Inactive"}
                      </Button>
                    </Stack>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          <Box paddingTop={4} display={"flex"} justifyContent={"center"}>
            <Pagination
              count={totalCount > 10 ? getPagination(totalCount) : 1}
              page={page}
              onChange={handleChangePage}
              color="primary"
            />
          </Box>
        </TableContainer>
      </Box>

      <DelModal
        open={openModal}
        handleClose={closeModalHandler}
        minitryDelHandler={minitryDelHandler}
      />
      <Backdrop
        sx={{
          zIndex: theme.zIndex.drawer + 1,
          color: theme.palette.primary.main,
        }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={alertOpen}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={alertIcon}>
          {alertMsg}
        </Alert>
      </Snackbar>
    </Box>
  );
};

export default Products;
